var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "footer-sticky-wrapper",
      style: _vm.appStyle,
      attrs: { id: "videoApp" },
    },
    [_c("router-view"), _vm._v(" "), !_vm.noFooter ? _c("Footer") : _vm._e()],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }